import { Component, Input, OnInit } from '@angular/core';
import { Persona } from '@app/shared/interfaces/persona';
import { onInitEffects } from '@ngrx/effects/src/lifecycle_hooks';

@Component({
  selector: 'app-persona',
  templateUrl: 'persona.component.html'
})
export class PersonaComponent {
  constructor() {}

  @Input() persona!:Persona;
}
